import { createSoucheInstance } from "./client";

const ins = createSoucheInstance();

export function getAllDataReportTypeList({ startMonth, endMonth, currentPage, pageSize }) {
  // https://disp-be-wf-dr.souche.com/dataReportCenter/getAllDataReportTypeList.json?typeId=&startMonth=2022-03-06&endMonth=2023-03-06&isCharge=&currentPage=1&pageSize=8
  return ins.execute({
    url: "https://disp-be-wf-dr.souche.com/dataReportCenter/getAllDataReportTypeList.json",
    query: {
      typeId: "",
      isCharge: "",
      startMonth,
      endMonth,
      pageSize,
      currentPage,
    },
  });
}
export function jsApiSignature() {
  return ins.execute({
    url: "https://da-vinci.souche.com/jsApiSignature/generate.json",
    query: {
      url: window.location.href,
      shopCode: "",
    },
  });
}



// WEBPACK FOOTER //
// ./src/api/index.js